<script setup lang="ts">
import { useHtmlContent } from '@shared';
import { computed, ref } from 'vue';

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  enabled: {
    type: Boolean,
    default: true
  },
  selected: {
    type: Boolean,
    default: false
  },
  size: {
    type: Number,
    default: 220
  },
  value: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: '#515151'
  },
  selectedColor: {
    type: String,
    default: 'rgb(var(--v-theme-primary))'
  },
  titleClass: {
    type: String,
    default: 'text-h5'
  }
});

defineEmits(['click']);

const { htmlContent } = useHtmlContent({ key: `statistics.wizard.statisticsType.${props.value}` });

const currentColor = computed(() => (props.selected ? props.selectedColor : props.color));

const opacity = computed(() => (props.enabled ? 1 : 0.7));

const border = computed(() => (props.selected ? `3px solid ${currentColor.value}` : 'none'));

const tooltipOpen = ref(false);
</script>

<template>
  <v-card
    v-click-outside="{ handler: () => (tooltipOpen = false) }"
    class="d-flex flex-column align-center justify-center statistics-type-card text-center"
    :class="{ 'statistics-type-card--disabled': !enabled }"
    :style="{ opacity, border }"
    :width="size"
    :height="size"
    :disabled="!enabled"
    :variant="selected ? 'flat' : 'elevated'"
    @click.prevent.stop="
      $emit('click', value);
      tooltipOpen = !tooltipOpen;
    ">
    <v-tooltip
      v-if="htmlContent"
      v-model="tooltipOpen"
      location="top"
      activator="parent"
      max-width="350px"
      :open-on-hover="false">
      <div v-html="htmlContent.html" />
    </v-tooltip>
    <v-card-title>
      <slot
        name="icon"
        :color="currentColor" />
    </v-card-title>
    <v-card-item>
      <span
        class="font-weight-light"
        :class="titleClass"
        :style="{ color: currentColor }">
        {{ title }}
      </span>
    </v-card-item>
  </v-card>
</template>
